import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class AssertSufficientCreditsArgs extends ActionArgs {
  /** Generic owner of the balance — a `User._id` or `Tenant._id`, per `resolveBillingOwnerId`. */
  @Field(() => ID)
  ownerId: string
}

/**
 * Hard-blocks a scan/AI call when the owner's balance is at or below zero. Cross-module
 * consumers (e.g. QuickScore) inject this by `IocKey.ai.service.assertSufficientCredits`,
 * typed via this interface — the concrete `AssertSufficientCredits` class stays internal
 * to `ai-node`.
 */
export interface IAssertSufficientCredits {
  execute(args: AssertSufficientCreditsArgs): Promise<void>
}
